import { FeatureFlag } from '../FeatureFlag';

/**
 * Replaces the per-result table in the LAB Order Debug drawer with the Evaluation Flow timeline,
 * a stage-by-stage account of how the order was evaluated. Proof of concept; the table stays one
 * toggle away while it is on.
 */
export const enableLabOrderEvaluationFlow = new FeatureFlag({
    key: 'enable-lab-order-evaluation-flow',
    defaultValue: false,
});
